import { createCustomEnum } from "./customEnum";

const SupportOptionsTypes = createCustomEnum({
	Bronze: {
		value: 1,
		name: "bronze",
		displayName: "Bronze",
	},
	Silver: {
		value: 2,
		name: "silver",
		displayName: "Silver",
	},
	Gold: {
		value: 3,
		name: "gold",
		displayName: "Gold",
	},
});

export default SupportOptionsTypes;
